import RoutesForm from '../components/RoutesForm.vue';
import Vue from 'vue';
const RoutesFormHandler = (item, callback) => {
  const vm = new Vue({
    ...RoutesForm,
    propsData: { item, callback },
  });
  vm.$mount();
  vm.$bvModal.show('routes-form-modal');
};
export default RoutesFormHandler;
